import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'
import {EVENT_SORT_ORDER} from '@wix/wix-events-commons-statics'
import {Override} from '../../commons/types/utils'

export interface ISettingsTexts {
  time: SettingsParamType.Text
  location: SettingsParamType.Text
  RSVPTitle: SettingsParamType.Text
  /**
   * @deprecated
   */
  registrationClosedButtonText: SettingsParamType.Text
  multiRsvpClosedBtnText: SettingsParamType.Text
  multiTicketedClosedBtnText: SettingsParamType.Text
  oneButton: SettingsParamType.Text
  /**
   * @deprecated
   */
  listButtonText: SettingsParamType.Text
  multiRsvpButtonText: SettingsParamType.Text
  multiTicketedButtonText: SettingsParamType.Text
  multiNoRegButtonText: SettingsParamType.Text
  todayButtonText: SettingsParamType.Text
  listGeneralTitle: SettingsParamType.Text
  soldOutRibbonText: SettingsParamType.Text
  joinWaitlistRibbonText: SettingsParamType.Text
  rsvpClosedRibbonText: SettingsParamType.Text
  membershipRibbonText: SettingsParamType.Text
  recurringRibbonText: SettingsParamType.Text
}

export interface ISettingsNumbers {
  filterType: SettingsParamType.Number
  sortOrder: SettingsParamType.Number
}

export interface ISettingsParams extends ISettingsNumbers, ISettingsTexts {}

export type WidgetComponentTextSettings = Override<ISettingsTexts, string>

const settingsParams = createSettingsParams<ISettingsParams>({
  time: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  location: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  RSVPTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  registrationClosedButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  multiRsvpClosedBtnText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  multiTicketedClosedBtnText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  oneButton: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  listButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  multiRsvpButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  multiTicketedButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  multiNoRegButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  todayButtonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  listGeneralTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  soldOutRibbonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  joinWaitlistRibbonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  rsvpClosedRibbonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  membershipRibbonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },
  recurringRibbonText: {
    type: SettingsParamType.Text,
    getDefaultValue: () => undefined,
  },

  filterType: {
    type: SettingsParamType.Number,
    getDefaultValue: () => undefined,
  },
  sortOrder: {
    type: SettingsParamType.Number,
    getDefaultValue: () => EVENT_SORT_ORDER.CHRONOLOGICAL,
  },
})

export default settingsParams
